// frontend/src/styles/theme.js

const theme = {
  colors: {
    primary: '#00C853',
    primaryDark: '#00B447',
    primaryLight: '#E8F5E9',
    textPrimary: '#212121',
    textSecondary: '#757575',
    background: '#FFFFFF'
  },
  // You can add more detailed structure as needed!
};

export default theme;
